import { render, staticRenderFns } from "./GoOrderPage.vue?vue&type=template&id=620ebf19&scoped=true&lang=pug&"
import script from "./GoOrderPage.vue?vue&type=script&lang=js&"
export * from "./GoOrderPage.vue?vue&type=script&lang=js&"
import style0 from "./GoOrderPage.vue?vue&type=style&index=0&id=620ebf19&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ebf19",
  null
  
)

export default component.exports